import { oneOf } from 'prop-types';
import { CURRENCIES } from 'common/constants/payment';

export const currencyType = oneOf(Object.values(CURRENCIES));
